import Button from 'components/ui/Button';
import Content from 'components/Content';
import CopyrightFooter from 'compositions/CopyrightFooter';
import Drawer from 'components/Drawer';
import Header from 'compositions/Header';
import Icons from 'components/icons';
import { FC, PropsWithChildren, useEffect, useRef } from 'react';
import { useAppSelector } from 'store/hooks';
import { selectUiState } from 'store/uiSlice';

type FullPageDrawerProps = PropsWithChildren<{
  isOpen?: boolean;
  onClose: () => void;
  onScrollTo?: (pos: number) => void;
  scrollPos?: number;
  transition?: 'fade' | 'slide';
}>;

const FullPageDrawer: FC<FullPageDrawerProps> = ({
  isOpen = false,
  onClose,
  children,
  transition = 'slide',
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const { dashboard } = useAppSelector(selectUiState) || {};

  const handleOnClose = () => {
    onClose();
    setTimeout(() => {
      if (ref?.current) {
        ref.current.scrollTo(0, 0);
      }
    }, 1000);
  };

  useEffect(() => {
    setTimeout(() => {
      const sectionElement = document.querySelector(
        `[data-section-id="${dashboard?.lightingKnowledge?.sectionId}"]`,
      );

      if (ref?.current) {
        if (sectionElement) {
          const scrollY =
            Number(sectionElement?.getBoundingClientRect().top) - 100;
          ref.current?.scrollTo({ left: 0, top: scrollY, behavior: 'smooth' });
        } else {
          ref.current.scrollTo(0, 0);
        }
      }
    }, 1000);
  }, [dashboard?.lightingKnowledge?.sectionId]);

  return (
    <Drawer
      transition={transition}
      isOpen={isOpen}
      onClose={onClose}
      position="bottom"
      speed="slow"
      className="z-50"
    >
      <div
        ref={ref}
        className="h-screen-ios bg-white overflow-y-scroll overflow-x-hidden relative"
      >
        <div className="grid grid-rows-[1fr_auto] min-h-full">
          <Content>
            <div className="fixed left-0 right-0 top-0 z-10">
              <Header
                leftButton={
                  <Button
                    style="onlyText"
                    color="blue"
                    onClick={handleOnClose}
                    className="!h-12 pr-8"
                    ariaLabel="close"
                  >
                    <Icons.Close />
                  </Button>
                }
              />
            </div>
            <div className="h-20" />

            {children}
          </Content>
          <CopyrightFooter />
        </div>
      </div>
    </Drawer>
  );
};

export default FullPageDrawer;
